import {
	GlobalExtension,
	type GlobalExtensionType,
	type ForgeUIExtensionType,
} from '@atlassian/forge-ui-types/private';

type FullForgeUIExtensionType = ForgeUIExtensionType & {
	properties: ForgeUIExtensionType['properties'] & {
		routePrefix?: string;
	};
};

export const globalExtensionURLHelpers: Partial<
	Record<GlobalExtensionType, (extension: FullForgeUIExtensionType, params?: any) => string | null>
> = {
	[GlobalExtension.FULL_PAGE]: ({ installationId, properties }) => {
		const { routePrefix } = properties;
		if (!routePrefix || !installationId) {
			return null;
		}
		return `/apps/full-page/${installationId}/${routePrefix}`;
	},
};
